import classNames from 'classnames'
import React from 'react'

import './Textarea.scss'

const Textarea = (
  props: Omit<
    React.DetailedHTMLProps<
      React.TextareaHTMLAttributes<HTMLTextAreaElement>,
      HTMLTextAreaElement
    >,
    'onChange'
  > & { onChange: (s: string) => void },
) => (
  <textarea
    {...props}
    className={classNames('textarea', 'inputField', props.className)}
    onChange={e => {
      props.onChange(e.currentTarget.value)
    }}
  />
)

export default Textarea
